import React, { Component } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import serverData from 'utils/server-data'
import location from '@paypalcorp/instance-location'

export default class Subheader extends Component {
  handlePrintClick = e => {
    e.preventDefault()
    window.print()
  }
  render() {
    const country = serverData.locality.country
    const language = serverData.locality.language
    const linkToLegalHub = `https://www.${location.getPayPalDomain()}/${country.toLowerCase()}/webapps/mpp/ua/legalhub-full?locale.x=${language}_${country}`
    return (
      <section className="user-agrmt-subheader-wrapper">
        <p className="legal-breadcrumbs-text">
          &gt;&gt;
          <a href={linkToLegalHub} title="Legal Agreements">
            {' '}
            <Message
              id={['app', 'userAgreemnet', 'subheader', 'viewAllAgreement']}
            />
          </a>
        </p>
        <div className="user-agrmt-template-print-icon-container">
          <img
            id="print_pic"
            src="https://${serverData.cdnHost}/webstatic/ua/printer_icon.jpg"
          />
          <a
            className="user-agrmt-template-print-icon"
            onClick={this.handlePrintClick}
          >
            <Message id={['app', 'default', 'subheader', 'print']} />
          </a>
        </div>
      </section>
    )
  }
}
